export const currencyTiers = {
  SMS: {
    USD: {
      tier1: '0.02',
      tier2: '0.016',
      tier3: '0.015',
    },
    GBP: {
      tier1: '0.016',
      tier2: '0.012',
      tier3: '0.012',
    },
    EUR: {
      tier1: '0.017',
      tier2: '0.014',
      tier3: '0.013',
    },
    MXN: {
      tier1: '0.365',
      tier2: '0.292',
      tier3: '0.274',
    },
    INR: {
      tier1: '1.289',
      tier2: '1.031',
      tier3: '0.967',
    },
    AUD: {
      tier1: '0.026',
      tier2: '0.020',
      tier3: '0.019',
    },
    CAD: {
      tier1: '0.025',
      tier2: '0.020',
      tier3: '0.019',
    },
  },
  MMS: {
    USD: {
      tier1: '0.060',
      tier2: '0.048',
      tier3: '0.045',
    },
    GBP: {
      tier1: '0.047',
      tier2: '0.037',
      tier3: '0.035',
    },
    EUR: {
      tier1: '0.052',
      tier2: '0.042',
      tier3: '0.039',
    },
    MXN: {
      tier1: '1.094',
      tier2: '0.876',
      tier3: '0.821',
    },
    INR: {
      tier1: '3.866',
      tier2: '3.093',
      tier3: '2.900',
    },
    AUD: {
      tier1: '0.077',
      tier2: '0.061',
      tier3: '0.058',
    },
    CAD: {
      tier1: '0.075',
      tier2: '0.060',
      tier3: '0.056',
    },
  },
};

export const formatCurrency = (currency, amount, minimumFractionDigits = 2) => {
  return new Intl.NumberFormat(navigator.language, { style: 'currency', currency, minimumFractionDigits }).format(
    amount
  );
};

export const formatPlainCurrency = (amount, minimumFractionDigits) => {
  return new Intl.NumberFormat(navigator.language, {
    style: 'decimal',
    minimumFractionDigits: minimumFractionDigits == null ? 2 : minimumFractionDigits,
  }).format(amount);
};

export const formatCurrencyIntoIntegerAndDecimal = (amount) => {
  const integerPartPrice = typeof amount === 'number' ? Math.floor(amount).toLocaleString(navigator.language) : '';
  const decimalPartPrice = typeof amount === 'number' ? (amount % 1).toFixed(2).split('.')[1] || '00' : '';

  return { integerPartPrice, decimalPartPrice };
};

const getCurrencySymbol = (currency) => {
  // eslint-disable-line
  if (currency) {
    return (0)
      .toLocaleString(navigator.language, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, '')
      .trim();
  }

  return '';
};

export const getIntegerDecimalsFromPrice = (price) => {
  const integer = formatPlainCurrency(Math.trunc(price), 0);
  let decimals = formatPlainCurrency((price - Math.trunc(price)) * 100, 0, 0);

  if (decimals.length === 1) {
    decimals = `0${decimals}`;
  }

  return [integer, decimals];
};

export default getCurrencySymbol;
